module.exports = __webpack_public_path__ + "img/frame_degree_m_2.8ed71ad2.png";